/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { path } from 'ramda';
import { createSelector } from 'reselect';
import { selectTenant, selectToken, selectOrg } from '@nebula/airglow-plugin-unified-shell/dist/selectors';
import { STORE_KEY } from '@nebula/airglow-plugin-unified-shell/dist/constants';

export const selectImsOrgName = path([STORE_KEY, 'session', 'imsOrgName']);

export const selectImsConfig = createSelector(
  selectToken,
  selectOrg,
  selectTenant,
  (imsAccessToken, imsOrg, tenant) => ({
    imsAccessToken,
    imsOrg,
    tenant
  })
);
